<template>
    <multiselect
        v-model="periodicityArray"
        :options="periodicityOptions"
        track-by="key"
        label="value"
        :multiple="true"
        :allowEmpty="false"
        placeholder="Seleccione"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {periodicityOptions} from '@/constants/fee-type-constants';

    export default {
        name: "PeriodicityMonthsMultipleSelector",
        components: {
            Multiselect
        },
        props: {
            value: Array // [1, 3, 6, 12]
        },
        data: function () {
            return {
                periodicityArray: this.evaluateValue(this.value)
            }
        },
        computed: {
            periodicityOptions() {
                let options = periodicityOptions.slice(0);
                options.unshift({
                    key: 'ALL',
                    value: 'Todas'
                });

                return options;
            }
        },
        methods: {
            evaluateValue(value) {
                if (Array.isArray(value) && !!value.length) {
                    let array = [];
                    value.forEach((periodicity) => {
                        if (
                            !!periodicity
                            && !!this.findPeriodicityByKey(periodicity)
                        ) {
                            array.push(this.findPeriodicityByKey(periodicity));
                        }
                    });
                    return array;
                } else {
                    return [];
                }
            },
            findPeriodicityByKey(key) {
                return periodicityOptions.find(periodicity => (periodicity.key === key));
            },
            selectAllOptions() {
                let index = this.periodicityArray.findIndex(periodicity => (periodicity.key === 'ALL'));
                if (index) {
                    this.periodicityArray.splice(index, 1);
                }

                this.periodicityArray = periodicityOptions.slice(0);
            },
            notifyChange(periodicityArray) {
                if (!!periodicityArray.find(periodicity => (periodicity.key === 'ALL'))) {
                    this.selectAllOptions();
                }

                this.$emit('input', this.periodicityArray.map(periodicity => (periodicity.key)));
            }
        },
        watch: {
            value: function () {
                this.periodicityArray = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>